import { useSetTransportOrderData } from "./useTransportOrderData";
import { useSetForwardingOrderData } from "./useForwardingOrderData";
import { useSetDriverData } from "./useDriverData";
import { useSetContractData } from "./useContractData";
import { useSetDeliveryData } from "./useDeliveryData.ts";
import { ViewNames } from "../../types";
import { useView } from "../../contexts/ViewContext.tsx";
import { useSetLocationData } from "./useLocationData.ts";
import { useSetCompanyData } from "./useCompanyData.ts";
import { useSetProductData } from "./useProductData.tsx";

function useLocationsSetter() {
  const { deleteData } = useSetLocationData();
  return {
    setData: () => [],
    deleteData,
  };
}

function useCompanySetter() {
  const { deleteData } = useSetCompanyData();
  return {
    setData: () => [],
    deleteData,
  };
}

function useProductSetter() {
  const { deleteData } = useSetProductData();
  return {
    setData: () => [],
    deleteData,
  };
}

const setterRegistry = {
  transportOrders: useSetTransportOrderData,
  forwardingOrders: useSetForwardingOrderData,
  contracts: useSetContractData,
  goodsToTakeAway: useSetContractData,
  drivers: useSetDriverData,
  deliveries: useSetDeliveryData,
  locations: useLocationsSetter,
  companies: useCompanySetter,
  products: useProductSetter,
} as const;

export type SetterRegistry = {
  [K in keyof typeof setterRegistry]: ReturnType<(typeof setterRegistry)[K]>;
};

export function useSetDataByView<
  TView extends ViewNames,
>(): SetterRegistry[TView] {
  const view = useView();
  return setterRegistry[view]() as SetterRegistry[TView];
}
